/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".row[_ngcontent-%COMP%]{margin:0 auto}  .tooltip-inner{width:-moz-fit-content;width:fit-content}.height-80[_ngcontent-%COMP%]{height:80px}.overflow-y[_ngcontent-%COMP%]{overflow-y:scroll}\n/*# sourceMappingURL=mapped-captains.component.css.map*/"];
export { styles as styles };
